import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { LoginScreen } from './screens/LoginScreen';
import { ChangePasswordScreen } from './screens/ChangePasswordScreen';
import { ShellLayout } from './screens/ShellLayout';
import { OverviewScreen } from './screens/OverviewScreen';
import { EarningsScreen } from './screens/EarningsScreen';
import { SubscribersScreen } from './screens/SubscribersScreen';
import { SettingsScreen } from './screens/SettingsScreen';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/change-password" element={<ChangePasswordScreen />} />
        <Route element={<ShellLayout />}>
          <Route path="/" element={<OverviewScreen />} />
          <Route path="/earnings" element={<EarningsScreen />} />
          <Route path="/earnings/:tab" element={<EarningsScreen />} />
          <Route path="/subscribers" element={<SubscribersScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
        </Route>
      </Route>
    </Routes>
  );
}
